/**
 * Если нужно, чтобы функция при каком-либо действии (resize, scroll, keydown)
 * выполнялась с определенной периодичностью, то используем throttle
 *
 * Если необходим вызов функции по окончании какого-либо действия, то используем debounce
 *
 * Если необходим вызов функции в начале какого-либо действия, то
 * используем debounce с дополнительным параметром немедленного вызова
 */

export function throttle(func, ms) {
  let locked = false // переменная которая отвечает за блокировку вызова функции

  return function () {
    // эта функция запускается при каждом событии

    if (locked) {
      return
    } // если заблокировано, то прекращаем выполнение этой функции

    const context = this // запоминаем передаваемую функцию func
    const args = arguments // запоминаем параметры передаваемой функции func

    locked = true // блокируем вызов функции

    setTimeout(() => {
      // устанавливаем время ожидания

      func.apply(context, args) // выполняем переданную функцию func
      locked = false // снимаем блокировку
    }, ms) // подставляем значение параметра ms
  }
}

export function debounce(func, ms, now) {
  let onLast // переменная отвечает за вызов функции func после того, как прошло время ожидания ms от последнего события

  return function () {
    // эта функция запускается при каждом событии

    const context = this // запоминаем передаваемую функцию func
    const args = arguments // запоминаем параметры передаваемой функции func

    const onFirst = now && !onLast // если хотим запустить функцию func при первом событии и время ожидания не установлено

    clearTimeout(onLast) // сбрасываем время ожидания ms

    onLast = setTimeout(() => {
      // устанавливаем время ожидания

      onLast = null // очищаем переменную onLast
      if (!now) {
        func.apply(context, args)
      } // если при первом событии функция func не была вызвана, то вызываем ее когда время ожидания ms закончилось
    }, ms) // подставляем значение параметра ms

    if (onFirst) {
      func.apply(context, args)
    } // запускаем функцию func при первом событии
  }
}
